export const ALLOWED_M3U_FILE_EXTENSIONS = ['m3u', 'm3u8', 'txt']

export const M3U_FILE_ACCEPT = ALLOWED_M3U_FILE_EXTENSIONS.map(
  ext => `.${ext}`
).join(',')

export const getFileExtension = fileName => {
  const parts = fileName.split('.')
  if (parts.length < 2) return ''
  return parts.pop().toLowerCase()
}

export const isAllowedM3uFile = file =>
  ALLOWED_M3U_FILE_EXTENSIONS.includes(getFileExtension(file.name))

export const getM3uFileValidationMessage = (invalidFiles = []) => {
  const base = `Only ${ALLOWED_M3U_FILE_EXTENSIONS.join(', ')} files are allowed.`
  if (!invalidFiles.length) return base
  return `${base} Invalid: ${invalidFiles.map(file => file.name).join(', ')}`
}
